import { Action } from '@ngrx/store';

export const SET_DRAWER_STATE = '[Drawer] Set Drawer State';
export const CHANGE_DRAWER_STATE = '[Drawer] Change Drawer State';

export class SetDrawerStateAction implements Action {
  readonly type = SET_DRAWER_STATE;

  constructor(public payload: object) {}
}

export class ChangeSettingAction implements Action {
  readonly type = CHANGE_DRAWER_STATE;

  constructor(public payload: object) {}
}

export type Actions = SetDrawerStateAction | ChangeSettingAction;
